import React from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';

import SurveyStepFooter from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepFooter';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';

import AccountSetupSection from '../../Components/AccountSetup/AccountSetupSection';

const styles = () => ({
  root: {},
  footer: {},
});

function AccountSetupPasswordSavedLayout({
  classes,
}) {
  const {
    onSubmit: onSubmitMetaForm,
  } = useMetaLayoutContext();

  return (
    <div className={classes.root}>
      {/* ---------- Section title / icon / message ---------- */}
      <AccountSetupSection
        icon={VerifiedUserIcon}
        title={'Password Saved!'}
        messages={['Continue with your account setup']}
      />

      {/* ---------- Footer (Navigator) ---------- */}
      <SurveyStepFooter
        className={classes.footer}
        onSubmit={onSubmitMetaForm}
        NextButtonProps={{
          test: 'survey-password-saved-continue-button',
        }}
      />
    </div>
  );
}

AccountSetupPasswordSavedLayout.propTypes = {
  classes: PropTypes.object.isRequired,
};

AccountSetupPasswordSavedLayout.defaultProps = {
};

export default withStyles(styles)(AccountSetupPasswordSavedLayout);
